import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '@core';

import { MatSnackBar } from '@angular/material/snack-bar';

import { JournalService, MailService, Mail } from '@core';

const log = new Logger('Support');

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  supportForm!: FormGroup;
  error: string;
  mailDebug: any = null;
  mailSmtpDebug: string = '';
  sending: boolean = false;
  showSupportDebug = environment.showSupportDebug;

  constructor(
    private formBuilder: FormBuilder,
    private mailService: MailService,
    private journalService: JournalService,
    private _snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  sendSupport() {
    this.mailDebug = null;
    this.mailSmtpDebug = '';
    this.sending = true;

    const support$ = this.mailService.send(this.supportForm.value);
    support$
      .pipe(
        finalize(() => {
          this.supportForm.markAsPristine();
          this.sending = false;
        })
        //untilDestroyed(this)
      )
      .subscribe(
        (data: any) => {
          console.log('[Support] Mail response:', data);
          console.log('[Support] mail_debug:', data.mail_debug);
          console.log('[Support] smtp_debug:', data.smtp_debug);

          this.mailDebug = data.mail_debug || [];
          this.mailSmtpDebug = data.smtp_debug || '';

          if (data.code == 200 && data.mail_success) {
            this._snackBar.open('Anfrage erfolgreich gesendet.', 'Schließen', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 3000,
            });
          } else {
            this._snackBar.open('Mail Fehler: ' + (data.mail_error || 'unbekannt'), 'Schließen', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 5000,
            });
          }

          log.debug(`support msg sent`);
          this.journalService.log('Support Anfrage gesendet.', '', '');
        },
        (error) => {
          this.sending = false;
          console.error('[Support] HTTP error:', error);
          this._snackBar.open('HTTP Fehler aufgetreten.', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
          log.debug(`Support sending error: ${error}`);
          this.error = error;
        }
      );
  }

  private createForm() {
    this.supportForm = this.formBuilder.group({
      subject: ['', Validators.required],
      message: ['', Validators.required],
      test_email: [''],
    });
  }
}
